import React from "react";
import { SectionHeading } from "../site/SectionHeading";
import { PHARMACY_PHOTOS, photoSrcSet } from "@/lib/site-data";

// Mosaic gallery — a curated glimpse of the pharmacy
const TILES = [
    { src: PHARMACY_PHOTOS.shelvesWide, alt: "Sélection dermocosmétique — La Roche-Posay, SVR, Filorga, Baija, La Rosée…", span: "lg:col-span-8 lg:row-span-2", aspect: "aspect-[16/10]" },
    { src: PHARMACY_PHOTOS.interior,    alt: "Espace conseil et matériel médical",                                          span: "lg:col-span-4", aspect: "aspect-square" },
    { src: PHARMACY_PHOTOS.mobility,    alt: "Aides à la mobilité — cannes, béquilles, location de fauteuils roulants",     span: "lg:col-span-4", aspect: "aspect-square" },
    { src: PHARMACY_PHOTOS.corner,      alt: "L'entrée latérale de la Pharmacie La Lutrive à Lutry",                        span: "lg:col-span-6", aspect: "aspect-[4/3]" },
    { src: PHARMACY_PHOTOS.shelves,     alt: "Espace boutique — nature, bébé, compléments",                                 span: "lg:col-span-6", aspect: "aspect-[4/3]" },
];

export const Gallery = () => {
    return (
        <section
            id="pharmacie"
            className="relative py-24 lg:py-32 bg-brand-cream border-y border-brand-line"
            data-testid="gallery-section"
        >
            <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
                <SectionHeading
                    eyebrow="Bienvenue chez nous"
                    title={<>Un lieu <span className="italic text-brand-primary">chaleureux</span>, pensé pour vous accueillir.</>}
                    subtitle="Rayonnage dermocosmétique, espace nature, matériel de location, coin bébé — poussez la porte et découvrez un espace lumineux à taille humaine."
                />

                <div
                    className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-3 lg:gap-4"
                    data-testid="gallery-grid"
                >
                    {TILES.map((t, i) => (
                        <figure
                            key={i}
                            className={`overflow-hidden group border border-brand-line bg-white ${t.span || ""}`}
                            data-testid={`gallery-tile-${i}`}
                        >
                            <img
                                src={t.src}
                                srcSet={photoSrcSet(t.src)}
                                sizes="(min-width: 1024px) 50vw, 100vw"
                                alt={t.alt}
                                loading="lazy"
                                className={`w-full h-full object-cover ${t.aspect} transition-transform duration-700 group-hover:scale-[1.02]`}
                            />
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Gallery;
